
















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import AppListItem from '@/components/AppListItem.vue';
import { ProductReport } from '@/interfaces/ProductReport';
import { Action } from 'vuex-class';

interface RefsInterface {
    itemList: AppListItem[],
}

@Component({
    name: 'AppList',
    components: {
        AppListItem,
    },
})
export default class AppList extends Vue {
    public $refs!: Vue['$refs'] & RefsInterface;

    @Prop() protected productReportList!: ProductReport[];
    @Prop({default: false}) protected isRemovable!: boolean;
    @Action('user/removeShoppingListRecords') protected removeShoppingListRecords!: (idsToBeRemoved: number[]) => void;

    protected get searchKeywords() {
        return this.$store.getters['search/searchKeywords'];
    }

    protected activeIndices: number[] = [];
    protected activeNames: string[] = [];

    public toggleAllIndices(value: boolean) {
        if (value) {
            this.activeIndices = this.productReportList.map((productReport) => productReport.id);
        } else {
            this.activeIndices = [];
        }
        const itemListElements = this.$refs.itemList;

        itemListElements.forEach((item) => item.checked = value);
    }

    protected onValueChange(valueObject: {
        value: boolean,
        id: number,
    }) {
        if (valueObject.value) {
            this.activeIndices.push(valueObject.id);
        } else if (!valueObject.value && this.activeIndices.includes(valueObject.id)) {
            this.activeIndices.splice(this.activeIndices.indexOf(valueObject.id), 1);
        }
        this.$emit('is-indeterminate', this.activeIndices.length > 0
            && this.activeIndices.length < this.productReportList.length);
    }

    protected onRemoveSingleRecord(idToBeDeleted: number) {
        this.removeShoppingListRecords([idToBeDeleted]);
        this.activeIndices.splice(this.activeIndices.indexOf(idToBeDeleted), 1);

    }

    protected onRemoveSelectedRecords() {
        this.$emit('remove-selected', this.activeIndices);
        this.activeIndices = [];
    }

    protected onOpenDeleteModal(idToBeDeleted: number) {
        this.$confirm('Are you sure you want to remove this record?', 'Delete confirmation', {
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel',
            distinguishCancelAndClose: true,
            type: 'warning',
        }).then(() => {
            this.$emit('remove-single', [idToBeDeleted]);
            const deletedItemIndex = this.activeIndices.indexOf(idToBeDeleted);
            if (deletedItemIndex !== -1) {
                this.activeIndices.splice(deletedItemIndex, 1);
            }
        });


    }

    protected beforeDestroy() {
        this.toggleAllIndices(false);
        this.$emit('active-indices-change', this.activeIndices);
    }

    @Watch('activeIndices')
    protected onActiveIndicesChange() {
        this.$emit('active-indices-change', this.activeIndices);
    }

}
